module.exports = __webpack_public_path__ + "media/images/pages/sample_brands/brand-dribbble-f8e798879752329b64cd7b626dde28ba.png";